import { SB } from '@play-co/replicant';

export const tutorialSchema = {
  tutorial: SB.object({
    basicGameplayShown: SB.boolean().default(false),
    chatWithPetsShown: SB.boolean().default(false),
    careForPetsShown: SB.boolean().default(false),
    petSickShown: SB.boolean().default(false),
    friendReferralShown: SB.boolean().default(false),
    profileShown: SB.boolean().default(false),
    match3Shown: SB.boolean().default(false),
    visitFriendShown: SB.boolean().default(false),
    adult: SB.boolean().default(false),
    duoInvite: SB.boolean().default(false),
    duoInviteReceived: SB.boolean().default(false),
  }),
};
